import {
  CartContainerProps,
  OnboardServicesByCruiseIdMyMSCResponseI,
} from '@msc-b2c/interfaces/types';
import { CartContainer } from './CartContainer';
import { useEffect, useState } from 'react';
import { GetExcursionsMyMSCResponse } from '@msc-b2c/interfaces/interfaces';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppDispatch,
  getActiveSession,
  RootState,
  scrollToTop,
  useGetBookingQuery,
} from '@msc-b2c/shared-utils';
import { skipToken } from '@reduxjs/toolkit/query';
import { getPricesCart } from '../utils/getPricesCart';

export function CartContainerWrapper(props: Readonly<CartContainerProps>) {
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setIsLoading] = useState(true);
  const { bookingNumber = '', cruiseId } = getActiveSession();
  const { data: booking } = useGetBookingQuery(bookingNumber !== '' ? bookingNumber : skipToken);
  const { items: cart, prices } = useSelector((state: RootState) => state.myAreaCart);
  const myMscExcursions: GetExcursionsMyMSCResponse | null =
    useSelector((state: RootState) => state.myCruise.excursions) || null;
  const myMscObs: OnboardServicesByCruiseIdMyMSCResponseI | null =
    useSelector((state: RootState) => state.myCruise.obs) || null;

  const removeCartSkeleton = () => {
    setIsLoading(false);
    const cartSkeleton = document.querySelector('.cmp-cart-checkout__skeleton');
    if (cartSkeleton) cartSkeleton.remove();
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (prices !== null) {
      removeCartSkeleton();
    }
  }, [prices]);

  useEffect(() => {
    if (cart.length === 0) {
      removeCartSkeleton();
    } else if (isLoading && booking && myMscExcursions !== null && myMscObs !== null && cruiseId) {
      getPricesCart(dispatch, cruiseId, bookingNumber, false)
        .catch(() => undefined)
        .finally(() => removeCartSkeleton());
    }
  }, [booking, isLoading, myMscExcursions, myMscObs, cruiseId, dispatch, bookingNumber]);

  return !isLoading && <CartContainer {...props} />;
}

CartContainerWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/cartcontainer';

export default CartContainerWrapper;
